import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../../router/all_routes';

const DueDrawn: React.FC = () => {
  const [viewType] = useState('Standard View');

  const [dueDrawnData] = useState([
    {
      year: '2016-2017',
      month: 'JAN 2017',
      basicDue: '90,290.00',
      specialDa: '0.00',
      hra: '0.00',
      hraDue: '25,291.00',
      leaveEncashment: '0.00',
      grossDue: '105,571.00',
      pfDue: '9,634.00',
      superannuation: '6,021.00',
      recovery: '15,655.00',
      netDue: '89,916.00',
      basicDrawn: '31,500.00',
      basicDeduction: '0.00',
      daDrawn: '35,091.00'
    },
    {
      year: '2016-2017',
      month: 'FEB 2017',
      basicDue: '90,290.00',
      specialDa: '0.00',
      hra: '0.00',
      hraDue: '25,291.00',
      leaveEncashment: '0.00',
      grossDue: '105,571.00',
      pfDue: '9,634.00',
      superannuation: '6,021.00',
      recovery: '15,655.00',
      netDue: '89,916.00',
      basicDrawn: '31,500.00',
      basicDeduction: '0.00',
      daDrawn: '35,091.00'
    },
    {
      year: '2016-2017',
      month: 'MAR 2017',
      basicDue: '90,290.00',
      specialDa: '0.00',
      hra: '0.00',
      hraDue: '25,291.00',
      leaveEncashment: '0.00',
      grossDue: '105,571.00',
      pfDue: '9,634.00',
      superannuation: '6,021.00',
      recovery: '15,655.00',
      netDue: '89,916.00',
      basicDrawn: '31,500.00',
      basicDeduction: '0.00',
      daDrawn: '35,091.00'
    },
    {
      year: '2016-2017',
      month: 'Arrear 2016-2017',
      basicDue: '0.00',
      specialDa: '0.00',
      hra: '0.00',
      hraDue: '0.00',
      leaveEncashment: '0.00',
      grossDue: '0.00',
      pfDue: '0.00',
      superannuation: '0.00',
      recovery: '0.00',
      netDue: '0.00',
      basicDrawn: '0.00',
      basicDeduction: '0.00',
      daDrawn: '0.00'
    },
    {
      year: '2017-2018',
      month: 'APR 2017',
      basicDue: '90,290.00',
      specialDa: '0.00',
      hra: '883.00',
      hraDue: '25,291.00',
      leaveEncashment: '0.00',
      grossDue: '104,968.00',
      pfDue: '9,526.00',
      superannuation: '6,021.00',
      recovery: '15,549.00',
      netDue: '89,139.00',
      basicDrawn: '31,500.00',
      basicDeduction: '0.00',
      daDrawn: '37,238.00'
    },
    {
      year: '2017-2018',
      month: 'MAY 2017',
      basicDue: '90,290.00',
      specialDa: '0.00',
      hra: '883.00',
      hraDue: '25,291.00',
      leaveEncashment: '0.00',
      grossDue: '104,968.00',
      pfDue: '9,526.00',
      superannuation: '6,021.00',
      recovery: '15,549.00',
      netDue: '89,139.00',
      basicDrawn: '31,500.00',
      basicDeduction: '0.00',
      daDrawn: '37,238.00'
    }
  ]);

  const downloadExcelFile = () => {
    // Create Excel content as CSV format
    const csvContent = [
      // Header row
      ['Year', 'Month', 'Basic Due', 'Special DA', 'Basic Due', 'DA Due', 'Perc Due', 'HRA Due', 'Leave Encashment Due', 'Gross Due', 'PF Due', 'Superannuation Due', 'Recovery Due', 'Net Due', 'Basic Drawn', 'Basic Dr', 'DA Drawn'].join(','),
      // Data rows
      ...dueDrawnData.map(item => [
        item.year,
        item.month,
        item.basicDue,
        item.specialDa,
        item.hra,
        item.hraDue,
        item.leaveEncashment,
        item.leaveEncashment,
        item.leaveEncashment,
        item.grossDue,
        item.pfDue,
        item.superannuation,
        item.recovery,
        item.netDue,
        item.basicDrawn,
        item.basicDeduction,
        item.daDrawn
      ].join(','))
    ].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `DMRC_Due_Drawn_Statement_${new Date().getFullYear()}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleExport = () => {
    downloadExcelFile();
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">Due Drawn</h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={all_routes.employeeDashboard}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="#">Other Services</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Due Drawn
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <button
                type="button"
                className="btn btn-success"
                onClick={downloadExcelFile}
                title="Download Due Drawn Statement"
              >
                <i className="ti ti-download me-2"></i>
                Download Excel
              </button>
            </li>
          </ul>
        </div>

        <div className="card">
          <div className="card-body p-0">
            {/* Control Bar */}
            <div className="d-flex justify-content-between align-items-center p-3 bg-light border-bottom">
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center gap-2">
                  <label className="form-label mb-0"><strong>View:</strong></label>
                  <select className="form-select form-select-sm" style={{ width: 'auto' }}>
                    <option value="standard">Standard View</option>
                    <option value="detailed">Detailed View</option>
                    <option value="summary">Summary View</option>
                  </select>
                </div>
                <div className="vr"></div>
                <button className="btn btn-outline-primary btn-sm">
                  <i className="ti ti-printer me-1"></i>
                  Print Version
                </button>
                <button className="btn btn-outline-success btn-sm" onClick={handleExport}>
                  <i className="ti ti-file-export me-1"></i>
                  Export Excel
                </button>
              </div>
            </div>

            {/* Data Table */}
            <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
              <table className="table table-bordered table-hover mb-0" style={{ fontSize: '11px' }}>
                <thead className="table-light sticky-top">
                  <tr>
                    <th style={{ minWidth: '80px', backgroundColor: '#f8f9fa' }}>Year</th>
                    <th style={{ minWidth: '100px', backgroundColor: '#f8f9fa' }}>Month</th>
                    <th style={{ minWidth: '80px', backgroundColor: '#f8f9fa' }}>Basic Due</th>
                    <th style={{ minWidth: '80px', backgroundColor: '#f8f9fa' }}>Special DA</th>
                    <th style={{ minWidth: '80px', backgroundColor: '#f8f9fa' }}>Basic Due</th>
                    <th style={{ minWidth: '80px', backgroundColor: '#f8f9fa' }}>DA Due</th>
                    <th style={{ minWidth: '80px', backgroundColor: '#f8f9fa' }}>Perc Due</th>
                    <th style={{ minWidth: '80px', backgroundColor: '#f8f9fa' }}>HRA Due</th>
                    <th style={{ minWidth: '120px', backgroundColor: '#f8f9fa' }}>Leave Encashment Due</th>
                    <th style={{ minWidth: '80px', backgroundColor: '#f8f9fa' }}>Gross Due</th>
                    <th style={{ minWidth: '80px', backgroundColor: '#f8f9fa' }}>PF Due</th>
                    <th style={{ minWidth: '110px', backgroundColor: '#f8f9fa' }}>Superannuation Due</th>
                    <th style={{ minWidth: '90px', backgroundColor: '#f8f9fa' }}>Recovery Due</th>
                    <th style={{ minWidth: '80px', backgroundColor: '#f8f9fa' }}>Net Due</th>
                    <th style={{ minWidth: '80px', backgroundColor: '#f8f9fa' }}>Basic Drawn</th>
                    <th style={{ minWidth: '70px', backgroundColor: '#f8f9fa' }}>Basic Dr</th>
                    <th style={{ minWidth: '80px', backgroundColor: '#f8f9fa' }}>DA Drawn</th>
                  </tr>
                </thead>
                <tbody>
                  {dueDrawnData.map((item, index) => (
                    <tr 
                      key={index} 
                      className={item.month.includes('Arrear') ? 'table-warning' : ''}
                      style={{ fontSize: '10px' }}
                    >
                      <td className="text-center">{item.year}</td>
                      <td className="text-center">{item.month}</td>
                      <td className="text-end">{item.basicDue}</td>
                      <td className="text-end">{item.specialDa}</td>
                      <td className="text-end">{item.hra}</td>
                      <td className="text-end">{item.hraDue}</td>
                      <td className="text-end">{item.leaveEncashment}</td>
                      <td className="text-end">{item.leaveEncashment}</td>
                      <td className="text-end">{item.leaveEncashment}</td>
                      <td className="text-end">{item.grossDue}</td>
                      <td className="text-end">{item.pfDue}</td>
                      <td className="text-end">{item.superannuation}</td>
                      <td className="text-end">{item.recovery}</td>
                      <td className="text-end">{item.netDue}</td>
                      <td className="text-end">{item.basicDrawn}</td>
                      <td className="text-end">{item.basicDeduction}</td>
                      <td className="text-end">{item.daDrawn}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DueDrawn;